import React from 'react'

export default () => (
  <div style={{ margin: '2rem auto', maxWidth: 500}}>Emil Indradjaja - <a href="mailto:emil@indradjaja.com">emil.indradjaja@gmail.com</a> - Cedar Park Texas</div>
)



// WEBPACK FOOTER //
// ./src/components/footer.js